export default [
  {
    id: 'OCC-LAT',
    name: 'Occidente Lateral',
    price: '340.00',
  },
  {
    id: 'ORI-LAT',
    name: 'Oriente Lateral',
    price: '235.00',
  },
  {
    id: 'NORTE',
    name: 'Norte',
    price: '80.00',
  },
  {
    id: 'SUR',
    name: ' Sur',
    price: '80.00',
  },
];
